import React from "react";
import { graphql, PageProps } from "gatsby";
import { SEO } from "../components/common/seo";
import {
  EventFragment,
  Venue,
  VenueDataFragment,
} from "../components/Pages/Venue";

interface VenueDataProps {
  venueData: {
    frontmatter: Omit<VenueDataFragment, "events">;
  };
  events: {
    edges: Array<{
      node: {
        frontmatter: EventFragment;
      };
    }>;
  };
}

const VenueTemplate: React.FC<PageProps<VenueDataProps>> = ({ data }) => {
  return (
    <>
      <SEO title={data.venueData.frontmatter.name} />

      <Venue
        {...data.venueData.frontmatter}
        events={data.events.edges.map(event => event.node.frontmatter)}
      />
    </>
  );
};

// eslint-disable-next-line import/no-default-export
export default VenueTemplate;

export const pageQuery = graphql`
  query($slug: String!, $events: [String!]!) {
    venueData: markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        name
        instagram
        information
        image {
          publicURL
        }
        description
        contact {
          content
          type
        }
        twitter
        status
        status_description
        social {
          type
          url
        }
      }
    }
    events: allMarkdownRemark(
      filter: { frontmatter: { specific: { in: $events } } }
    ) {
      edges {
        node {
          frontmatter {
            title
            subtitle
            specific
            description
            earliest
            image {
              publicURL
            }
          }
        }
      }
    }
  }
`;
